import { oc } from '@orpc/contract'
import { z } from 'zod'
import { creditsResetModeSchema } from './credits'

export const organizationSummarySchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  slug: z.string().min(1),
  prefix: z.string().nullable(),
  role: z.enum(['owner', 'admin', 'member']),
})

export const organizationsListForMeContract = oc.input(z.object({}).optional()).output(
  z.object({
    items: z.array(organizationSummarySchema),
  })
)

export const organizationsGetContract = oc
  .input(z.object({ organizationId: z.string().min(1) }))
  .output(
    z.object({
      organization: z.object({
        id: z.string(),
        name: z.string(),
        slug: z.string(),
        projectLimit: z.number(),
        projectCount: z.number(),
        /** Credits: the budget, what is spent this window, and how it resets. */
        creditLimit: z.number(),
        creditsUsed: z.number(),
        creditsReset: creditsResetModeSchema,
        creditsPeriodEnd: z.string().nullable(),
        memberCount: z.number(),
        signupMode: z.enum(['invite_only', 'domain_restricted']),
        allowedEmailDomain: z.string().nullable(),
        requiredAuthProvider: z.enum(['google', 'microsoft']).nullable(),
        isActive: z.boolean(),
        createdAt: z.string(),
      }),
    })
  )

export const orgMemberSchema = z.object({
  userId: z.string(),
  email: z.string(),
  name: z.string().nullable(),
  avatarUrl: z.string().nullable(),
  role: z.enum(['owner', 'admin', 'member']),
  isGuest: z.boolean(),
  disabledAt: z.string().nullable(),
  joinedAt: z.string(),
})

export const organizationsListMembersContract = oc
  .input(z.object({ organizationId: z.string().min(1) }))
  .output(z.object({ members: z.array(orgMemberSchema) }))

export const organizationsUpdateMemberContract = oc
  .input(
    z.object({
      organizationId: z.string().min(1),
      userId: z.string().min(1),
      role: z.enum(['owner', 'admin', 'member']).optional(),
      isGuest: z.boolean().optional(),
    })
  )
  .output(z.object({ ok: z.literal(true) }))

export const organizationsUpdateSettingsContract = oc
  .input(
    z.object({
      organizationId: z.string().min(1),
      requiredAuthProvider: z.enum(['google', 'microsoft']).nullable().optional(),
    })
  )
  .output(z.object({ ok: z.literal(true) }))

export const organizationsToggleMemberDisabledContract = oc
  .input(
    z.object({
      organizationId: z.string().min(1),
      userId: z.string().min(1),
      disabled: z.boolean(),
    })
  )
  .output(z.object({ ok: z.literal(true) }))
